<? if( visit.hasError() ) { ?>
	<div class="sync p-3 bg-danger color-white">
		<p class="small uc text-center mb-0"><i class="fas fa-fw fa-exclamation-triangle"></i> Il y a <?=_.size(visit.getErrors())?> erreur(s)</p>
	</div>
<? } else if( visit.get('saving') ) { ?>
	<div class="sync p-3 bg-warning color-white">
		<p class="small uc text-center mb-0"><i class="fas fa-fw fa-spinner fa-spin"></i> Envoi des données en cours</p>
	</div>
<? } ?>

<div class="p-3 bg-green color-white">
	<p class="small uc text-center mb-0">Détails de la visite</p>
</div>

<div class="p-3 text-center bb">
	<p>
		<? if( !pond.isNew() ) { ?>
			<a href="#<?=pond.toUrl('pond/view')?>" class="badge badge-dark badge-lg fw-400 mr-1">Mare #<span class="pond_id"><?=pond.toFixed( 'id', 0 )?></span></a>
		<? } else if( app.is('online') ) { ?>
			<a href="#<?=pond.toUrl('pond/view')?>" class="badge badge-dark badge-lg fw-400 mr-1">Mare #<i class="fas fa-fw fa-spinner fa-spin"></i></a>
		<? } else { ?>
			<a href="#<?=pond.toUrl('pond/view')?>" class="badge badge-dark badge-lg fw-400 mr-1">Mare <i class="fad fa-xs fa-fw fa-wifi-slash"></i></a>
		<? } ?>
		<span class="badge badge-<?=pond.getStatus().color?> badge-lg fw-400"><?=pond.getStatus().name?></span>
	</p>
	<p class="text-center mb-0">Visite du <?=visit.getDate('date')?></p>
	<? if( visit.has('user_name') ) { ?>
		<p class="text-center text-secondary small mb-0">par <?=visit.get('user_name')?></p>
	<? } ?>
</div>

<div class="p-3 bg-light bb">
	<? if( visit.isNew() ) { ?>
		<div class="d-flex justify-content-between align-items-center">
			<span class="small uc text-secondary">Visite en attente d'envoi</span>
			<? if( app.is('online') ) { ?>
				<button id="visit_sync" class="btn btn-sm btn-green btn-sync"><i class="far fa-fw fa-cloud-upload"></i> Publier</button>
			<? } else { ?>
				<button class="btn btn-sm btn-green" disabled><i class="fad fa-fw fa-wifi-slash"></i> Publier</button>
			<? } ?>
		</div>
	<? } else if ( visit.get('todo') == 'draft' ) { ?>
		<div class="d-flex justify-content-between align-items-center">
			<span class="small uc text-secondary">Modification en attente</span>
			<? if( app.is('online') ) { ?>
				<button id="visit_sync" class="btn btn-sm btn-green btn-sync"><i class="far fa-fw fa-cloud-upload"></i> Publier</button>
			<? } else { ?>
				<button class="btn btn-sm btn-green" disabled><i class="fad fa-fw fa-wifi-slash"></i> Publier</button>
			<? } ?>
		</div>
	<? } else { ?>
		<p class="small uc text-center text-secondary mb-0">Visite envoyée le <?=visit.getDate('updated_at')?></p>
	<? } ?>
</div>

<div id="visit-details">
	<div class="list-group">
		<? _.each( form, function( section ) { ?>
			<? _.each( section.list, function( field ) { ?>
				<? if( visit.get(field.id) || visit.hasError(field.id) ) { ?>
					<div id="field-<?=section.id+'-'+field.id?>" class="list-group-item">
						<span class="small text-secondary"><?-field.name?></span>
						<? if( field.type == 'date' ) { ?>
							<br/><?=visit.getDate(field.id)?>
						<? } else if( field.type == 'textarea' ) { ?>
							<? _.each( visit.get(field.id).split("\n"), function( p ) { ?>
								<br/><?=p?>
							<? }) ?>
						<? } else if( _.isArray( visit.get(field.id) ) ) { ?>
							<? _.each( visit.get(field.id), function( p ) { ?>
								<br/><?=p?>
							<? }) ?>
						<? } else { ?>
							<br/><?=visit.get(field.id)?>
						<? } ?>
						<? if( visit.hasError(field.id) ) { ?>
							<br/><strong class="invalid-feedback d-block"><?=visit.getError(field.id)?></strong>
						<? } ?>
					</div>
				<? } ?>
			<? }) ?>
		<? }) ?>
	</div>
</div>

<? if( visit.isNew() || visit.get('user_uuid') == app.getStore('user').get('uuid') ) { ?>
	<div class="p-3">
		<div class="d-flex justify-content-between">
			<a href="#<?=visit.toUrl('visit/manage')?>" class="btn btn-green btn-edit btn-block"><i class="far fa-edit"></i> Modifier la visite</a>
			<button data-toggle="modal" data-target="#visit-delete-modal" class="btn btn-dark btn-delete ml-3"><i class="far fa-fw fa-trash-alt"></i></button>
		</div>
	</div>

	<div id="visit-delete-modal" class="modal">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Attention !</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<p>Vous êtes sur le point de supprimer une visite détaillée.<br/><br/>Veuillez confirmer cette action.</p>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
					<button id="visit_delete_modal_confirm" type="button" class="btn btn-green">Confirmer</button>
				</div>
			</div>
		</div>
	</div>
<? } ?>

